/** VUEX Project manager
 *
 * @requires Dau.js
 * @requires Project.js
 * @requires ProjectsAPI.js
 */
import {bus} from '@store/dau';
import {App, utils} from '@3cad/nextcore';
import {CrulesAPI, HandlerAPI, ProjectsAPI, GalleryAPI} from '@3cad/nextcore';
import {RowEval} from '@3cad/nextcore';
let { loadJson } = utils

export const projectManager = {
    namespaced: true,
    state: App.getProject(),

    // Get project object's properties
    getters: {
        /** Get last history element of project
         * @param state
         * @param getters
         */
        history: (state, getters) => {
            return state.history[state.history.length - 1]
        },
        /** Get warnings table
         * @param state
         * @returns {Array}
         */
        warnings: (state) => {
            return state.getWarningsTable();
        },
        currentRow: (state) => {
            return state.getCurrentRow();
        },
        total: (state, getters) => (withTaxes = false, withCamp = false, withDeliver = false, withDisc = false) => {
            return state.prjTotal(withTaxes, withCamp, withDeliver, withDisc);
        },
        volume: (state) => {
            return state.getVolume();
        },
        weight: (state) => {
            return state.getWeight();
        }
    },
    // Mutate project object
    mutations: {
        empty(state) {
            //let prj = new Project();
            //Object.assign(state, prj);
            //state.isopen = false;
            App.emptyPrj();

            if(state)
                App.iCad.setProject(state);

            // bus.$emit('SET_PROJECT', state);

            // TODO: Per oscar
            /*if(this.state.cad)
                this.state.cad.inputWrapper.setProject(state);*/

            //Object.assign(state, new Project());
        },
        merge(state, data) {

            // Update project structure
            state.mergeJson(data);

            // bus.$emit('SET_PROJECT', state);

            // TODO: Per oscar
            /*if(this.state.cad)
                this.state.cad.inputWrapper.setProject(state);*/
        },
        addHistory(state, {catalog: catalog, model: model}) {
            state.pushHistory(catalog, model);
        },
        addNewRow(state, type) {
            state.addNewRow(type);
        },
        recompute(state, {data: data, overwriteImg: overwriteImg}) {
            state.recompute(data, overwriteImg);
        },
        saveViews(state, views = []) {
            state.engine_views = views;
        }
    },
    // Async operations in project object
    actions: {
        /** Save project
         * @param context
         * @param clone Boolean - Clone project as new project
         * @param isOffer Boolean
         * @returns {Promise}
         */
        async save(context, {clone = false, isOffer = false}) {
            let config = this.getters['getConfig'];
            // TODO: Se le righe progetto contengono l'intera regola allora prima del salva progetto eliminare il campo rule da ogni riga progetto
            return App.savePrj(clone, config, isOffer);
        },
        /** Load project
         * @param context
         * @param data
         * @returns {Promise}
         */
        async load(context, data) {
            return App.loadProject(data.id);
        },

        /** Load gallery
         * This function apply and reval gallery
         * @param context
         * @param catalog
         * @param cod
         */
        async loadGallery(context, {catalog, cod}) {
            return App.loadGallery(catalog, cod);
        },
        async evalDivider(context, {catalog, rule, divider}) {
            return App.evalDivider(catalog, rule, divider);
        },
        /** Reval all project boxes
         * @param context
         * @param start {Boolean} Used for recursive calling, call first time always with true
         * @param progress {Function}
         * @returns {Promise}
         */
        async revalAll(context, {
            start = true, progress = progress => {
                console.log(progress);
            }
        }) {
            let prj = context.state;
            if (start)
                prj.rows.forEach(r => {
                    r.jeval3ddone = false;
                })

            return new Promise((resolve, reject) => {
                let noEvalRows = prj.rows.filter(r => {
                    return !r.jeval3ddone && !r.auto && !r.local
                });
                progress((prj.rows.length - noEvalRows.length) / prj.rows.length);

                if (noEvalRows.length > 0) {
                    if (!noEvalRows[0].rule) {
                        CrulesAPI.loadRule(
                            noEvalRows[0].catalog,
                            noEvalRows[0].reg,
                            '',
                            noEvalRows[0].cmodel,
                            noEvalRows[0].cod,
                            noEvalRows[0].model,
                            noEvalRows[0].neutro,
                            (rule) => {
                                noEvalRows[0].rule = rule;

                                if (noEvalRows[0].wallItem) {
                                    noEvalRows[0].jeval3ddone = true;
                                    context.dispatch('revalAll', {start: false, progress: progress}).then(resolve)
                                } else {
                                    RowEval.eval(noEvalRows[0])
                                        .then(() => {
                                            context.dispatch('revalAll', {start: false, progress: progress}).then(resolve)
                                        })
                                        .catch(() => {
                                            noEvalRows[0].jeval3ddone = true; //pessimo la ricorsione dovrebbe avere un contatore
                                            context.dispatch('revalAll', {start: false, progress: progress}).then(resolve)
                                        })
                                    /*context.dispatch('eval', { rule: noEvalRows[0].rule, row: noEvalRows[0] })
                                        .then( () => {
                                            context.dispatch('revalAll', { start: false, progress: progress }).then(resolve)
                                        })
                                        .catch(() => {
                                            noEvalRows[0].jeval3ddone = true; //pessimo la ricorsione dovrebbe avere un contatore
                                            context.dispatch('revalAll', { start: false, progress: progress }).then(resolve)
                                        })*/
                                }
                            }
                        );
                    } else {
                        if (noEvalRows[0].wallItem) {
                            noEvalRows[0].jeval3ddone = true;
                            context.dispatch('revalAll', {start: false, progress: progress}).then(resolve)
                        } else {
                            RowEval.eval(noEvalRows[0])
                                .then(() => {
                                    context.dispatch('revalAll', {start: false, progress: progress}).then(resolve)
                                })
                                .catch(() => {
                                    noEvalRows[0].jeval3ddone = true;//pessimo la ricorsione dovrebbe avere un contatore
                                    context.dispatch('revalAll', {start: false, progress: progress}).then(resolve)
                                });
                            /*context.dispatch('eval', { rule: noEvalRows[0].rule, row: noEvalRows[0] })
                                .then( () => {
                                    context.dispatch('revalAll', { start: false, progress: progress }).then(resolve)
                                })
                                .catch(() => {
                                    noEvalRows[0].jeval3ddone = true;//pessimo la ricorsione dovrebbe avere un contatore
                                    context.dispatch('revalAll', { start: false, progress: progress }).then(resolve)
                                });*/
                        }
                    }
                } else
                    resolve();
            });
        },
        /** recompute prices
         * @param context
         * @param overwriteImg
         * @returns {Promise}
         */
        async recompute(context, {overwriteImg: overwriteImg = true}) {
            return new Promise((resolve, reject) => {
                let data = context.state.getEvalProjectData();
                CrulesAPI.calcolaRivaluta(data, (res) => {
                    context.state.setEvalProjectData(res);
                    switch (context.state.status.toLowerCase()) {
                        case 'unassigned':
                        case 'assigned':
                        case 'seller design':
                            context.state.priceDate = (new Date()).toInt();
                            break;
                    }

                    let encodePrj = context.state.getJson();
                    for (let i = 0; i < encodePrj.rows.length; i++) {
                        let r = encodePrj.rows[i];
                        encodePrj.rows[i] = {
                            uniqueid: r.uniqueid,
                            boxid: r.boxid,
                            catalog: r.catalog,
                            model: r.model,
                            cmodel: r.cmodel,
                            neutro: r.neutro,
                            erp: r.erp
                        }
                    }
                    ProjectsAPI.recomputePrices(encodePrj, json => {
                        // Merge only ERP
                        context.commit('recompute', {data: json, overwriteImg: overwriteImg});
                        resolve(json);
                    }, err => {
                        reject(err);
                    });
                }, reject);
            })
        },
        async cadCallBackEvalTop(context, {data = null}) {
            return new Promise((resolve, reject) => {
                let evalData = context.state.getEvalProjectData(null);
                CrulesAPI.calcolaRivaluta(evalData, (res) => {
                    context.state.setEvalProjectData(res);
                    resolve(res);

                }, err => {
                    reject(err);
                }, 0);
            });
        },

        /** Generate views
         * @param context
         * @returns {Promise}
         */
        async generateViews(context, {mode2D = false}) {
            return new Promise((resolve, reject) => {
                let wallWrapper = this.state.cad.inputWrapper;
                /*let x = this;
                debugger;
                function callbackForReval(tipo, data) {
                    switch (tipo) {
                        case Eng3d_Callbacks.CB_EVALUATE_WALLS:
                            wallWrapper.saveWalls();
                            CrulesAPI.cadCallBackEvalWalls(data);
                            break;
                        case Eng3d_Callbacks.CB_EVALUATE_TOPS:
                            x.dispatch("project/cadCallBackEvalTop", {data});
                            break;
                        case Eng3d_Callbacks.CB_SCRIPT_QUOTE:
                            CrulesAPI.cadCallbackScriptQuote(data);
                            break;
                        case(Eng3d_Callbacks.DONWLOAD_PHOTOMATCH_IMG):
                            App.downloadPhotoMatchImg(data);
                            break;
                        default:
                            console.warn('Manage', tipo, data);
                            break;
                    }
                }*/

                //tmpCadEng.generalCallback = callbackForReval;
                let config = this.getters['getConfig'];
                //alert(config.noAntiAlias);

                let is2D = mode2D;

                App.iCad.renderAllViews(context.state, loadJson, config, (json) => {
                    ProjectsAPI.saveViewMaker(json, () => {
                        resolve(json);
                    }, reject);
                    //resolve(json);
                }, false, is2D, null, wallWrapper, config.noAntiAlias);

            })
        },
        /** Create PDF of project
         * @param context
         * @param catalog
         * @param prints
         * @param name
         * @param validity
         * @returns {Promise}
         */
        async createPdf(context, {catalog, prints, name = 'offer', validity = '', customer = ''}) {
            return new Promise((resolve, reject) => {
                context.state.isoffer = 0

                let prt = []

                for (let i = 0; i < prints.length; i++) {
                    if (prints[i].value === 1) {
                        prt.push(prints[i].stn)
                    }
                }

                prt = prt.join(';')
                console.warn(customer)
                ProjectsAPI.prjCreatePDF2(context.state.id, catalog, customer, name, prt, validity, resolve, reject);
            })
        },
        /**
         *
         * @param context
         * @param name
         * @returns {Promise}
         */
        async createVersion(context, {name}) {
            return new Promise((resolve, reject) => {
                ProjectsAPI.prjVersionCreate(context.state.id, name, json => {
                    resolve(json);
                });
            });
        },
        async restoreVersion(context, {id = context.state.id, versionName}) {
            return new Promise((resolve, reject) => {
                ProjectsAPI.prjVersionRestore(id, versionName,
                    json => {
                        resolve(json);
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },
        /** Set project status
         * @param context
         * @param prjId
         * @param status
         * @param toShop
         * @param toUser
         * @param extraData
         * @returns {Promise}
         */
        async setStatus(context, {prjId, status, toShop = '', toUser = 0, extraData = ''}) {
            return new Promise((resolve, reject) => {
                ProjectsAPI.setstatus(prjId, status, toShop, toUser, extraData, json => {
                    if (json && (prjId === context.state.id)) {
                        context.commit('merge', json);
                        resolve(json);
                    } else {
                        resolve(json);
                    }
                }, reject);
            });
        },
        async savePhotoMatch(context, photoJSON) {
            return new Promise((resolve, reject) => {
                let urlpic = photoJSON.urlpic;
                let imgName = photoJSON.urlpic.slice(photoJSON.urlpic.lastIndexOf("/") + 1, photoJSON.urlpic.length);
                let prj = context.state;

                let xhr = new XMLHttpRequest();
                xhr.open("GET", urlpic);
                xhr.responseType = "blob";
                xhr.onload = function () {
                    let blob = xhr.response;
                    let imageToUpload = new File([blob], imgName + '.jpg', {type: 'image/jpeg'});
                    HandlerAPI.uploadFiles([imageToUpload], prj.id,
                        evt => {
                            App.getLoaderManager().progressWithTotal(evt.loaded, evt.total);
                        },
                        res => {
                            App.getLoaderManager().stop();
                            this.saving = false;
                            //photoJSON.urlpic = res.;
                            photoJSON.fileName = res.filename;
                            prj.savePhotoMatch(photoJSON);
                        },
                        err => {
                            if (err.internal_error === 'E05')
                                prj.savePhotoMatch(photoJSON);
                            else {
                                console.error(err);
                            }
                            App.getLoaderManager().stop();
                        });
                };
                xhr.send();

            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/_eng/store/projectStore.js